import { render, staticRenderFns } from "./cuotizhuankao-pop.vue?vue&type=template&id=bd18c1a4&scoped=true"
import script from "./cuotizhuankao-pop.vue?vue&type=script&lang=js"
export * from "./cuotizhuankao-pop.vue?vue&type=script&lang=js"
import style0 from "./cuotizhuankao-pop.vue?vue&type=style&index=0&id=bd18c1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd18c1a4",
  null
  
)

export default component.exports